import React, { useEffect } from 'react';

function animateProgress(start, end, startMin, endMin, startMax, endMax, duration, drawFunction) {
    const startTime = performance.now();

    function animation(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1); // Ensure progress does not exceed 1

        const currentValue = start + (end - start) * progress;
        const currentMin = startMin + (endMin - startMin) * progress;
        const currentMax = startMax + (endMax - startMax) * progress;

        // Call the draw function with current values
        drawFunction(currentValue, currentMin, currentMax);

        if (progress < 1) {
            requestAnimationFrame(animation);
        }
    }

    requestAnimationFrame(animation);
}

function drawProgress(canvasId, value, minValue, maxValue, progressValueId, minValueId, maxValueId) {
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height;
    const radius = 85;
    const thickness = 30;
    const startAngle = Math.PI;

    // Function to draw the progress bar
    function draw(currentValue, currentMin, currentMax) {
        const endAngle = Math.PI * (1 + (currentValue - currentMin) / (currentMax - currentMin));

        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw the background arc
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, startAngle, Math.PI * 2);
        ctx.lineWidth = thickness;
        ctx.strokeStyle = '#ddd';
        ctx.stroke();

        // Determine the color based on value percentage
        const progressPercentage = ((currentValue - currentMin) / (currentMax - currentMin)) * 100;
        let color;
        if (progressPercentage < 34) {
            color = '#EA1414';  // Dark Red
        } else if (progressPercentage >= 34 && progressPercentage < 67) {
            color = '#E99714';  // Dark Yellow
        } else {
            color = '#21862A';  // Green
        }

        // Draw the progress arc
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.lineWidth = thickness;
        ctx.strokeStyle = color;
        ctx.stroke();

        // Update the text color and value
        document.getElementById(progressValueId).style.color = color;
        document.getElementById(progressValueId).innerText = formatValue(currentValue);
        document.getElementById(minValueId).innerText = formatValue(currentMin); 
        document.getElementById(maxValueId).innerText = formatValue(currentMax);
    }

    function formatValue(value) {
        return value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
    }

    // Retrieve previous values from localStorage or use defaults if not available
    const prevValue = parseFloat(localStorage.getItem(progressValueId)) || 0;
    const prevMin = parseFloat(localStorage.getItem(`${progressValueId}_min`)) || minValue;
    const prevMax = parseFloat(localStorage.getItem(`${progressValueId}_max`)) || maxValue;

    // Save the new values to localStorage
    localStorage.setItem(progressValueId, value);
    localStorage.setItem(`${progressValueId}_min`, minValue);
    localStorage.setItem(`${progressValueId}_max`, maxValue);

    // Call the animateProgress function
    animateProgress(prevValue, value, prevMin, minValue, prevMax, maxValue, 1000, draw);
}

function ProgressBar({ canvasId, value, minValue, maxValue, progressValueId, minValueId, maxValueId, barLabel }) {
    // Use useEffect to run drawProgress after the component is rendered
    useEffect(() => {
        drawProgress(canvasId, value, minValue, maxValue, progressValueId, minValueId, maxValueId);
    }, [canvasId, value, minValue, maxValue, progressValueId, minValueId, maxValueId]);

    return (
        <div className="progress-item">
            <div className="canvas-container">
                <canvas id={canvasId} width="200" height="100"></canvas>
                <div className="progress-value" id={progressValueId}>{formatValue(value)}</div>
            </div>
            <div className="progress-labels">
                <span className="sell" id={minValueId}>{formatValue(minValue)}</span>
                <span className="buy" id={maxValueId}>{formatValue(maxValue)}</span>
            </div>
            <div className="bar-label">{barLabel}</div>
        </div>
    );
}

function formatValue(value) {
    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
}

export default ProgressBar;
